import { render } from "./AdminStatistics.vue?vue&type=template&id=4db1b7fe&scoped=true&ts=true"
import script from "./AdminStatistics.vue?vue&type=script&lang=ts"
export * from "./AdminStatistics.vue?vue&type=script&lang=ts"

import "./AdminStatistics.vue?vue&type=style&index=0&id=4db1b7fe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4db1b7fe"]])

export default __exports__